import React from 'react';
import styled, { keyframes } from 'styled-components';
import { animations } from '../../design-system/tokens/animations';

const slideFadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Panel = styled.div`
  width: 100%;

  @media (prefers-reduced-motion: no-preference) {
    animation: ${slideFadeIn} ${animations.duration.normal}ms ${animations.easing.easeOut} both;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export interface WizardStepPanelProps {
  /** Changes when the step changes so React remounts and replays the enter animation. */
  stepKey: string | number;
  children: React.ReactNode;
  className?: string;
  /** Optional accessible label for the step region. */
  'aria-label'?: string;
}

/**
 * Wraps wizard step content with a calm enter animation.
 * Respects prefers-reduced-motion.
 */
export const WizardStepPanel: React.FC<WizardStepPanelProps> = ({
  stepKey,
  children,
  className,
  'aria-label': ariaLabel,
}) => (
  <Panel
    key={stepKey}
    className={className}
    role="region"
    aria-label={ariaLabel}
  >
    {children}
  </Panel>
);

export default WizardStepPanel;
